import React from 'react';
import { ScrollView, View } from 'react-native';
import {
  Bank_name_str,
  contactListName,
  creditCardCodeNumber,
  getAvatarColor,
  hashtag,
  me_txt,
  phone_number_one, phone_number_zero,
  Phone_str,
} from '../../utils/DictionaryManagementUtils';
import MyContactLine from './MyContactLine';

//= ========================================================================

const ContactListScroll = ({
  globJSON,
  simPlatform,
  withSelected,
  withExpand = false,
  withMe,
  withCircle = false,
}) => {
  const { colors } = globJSON.configurations.theme;
  const numOfAvatarsColors = 4;
  const colorToUse = (index) => {
    if (colors[getAvatarColor(index)] === hashtag) {
      return colorToUse(index === 1 ? numOfAvatarsColors : index - 1);
    }
    return colors[getAvatarColor(index)];
  };
  const getColorIndex = (index) => (index % 4) + 1;

  return (
    <ScrollView
      style={{
        flexDirection: 'column',
      }}
      vertical
      pagingEnabled={false}
      showsVerticalScrollIndicator={false}
      scrollEnabled
    >

      {withMe && (
        <MyContactLine
          simPlatform={simPlatform}
          globJSON={globJSON}
          txtInitials={me_txt}
          txtPrimary={me_txt}
          withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
          withExpand={false}
          withCollapse={false}
          avatarColor={colorToUse(getColorIndex(0))}
          selectedContact={withSelected}
          withCircle={withCircle}
        />
      )}

      {(contactListName.map((userName, index) => (!(withExpand && index === 0) ? (
        <MyContactLine
          simPlatform={simPlatform}
          globJSON={globJSON}
          txtInitials={userName.userInitialsName}
          txtPrimary={userName.userName}
          txtSecondary={!withExpand && creditCardCodeNumber}
          withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
          avatarColor={colorToUse(getColorIndex(index))}
          withExpand={withExpand}
          withCircle={withCircle}
          key={index}
        />
      ) : (
        <View>
          <MyContactLine
            simPlatform={simPlatform}
            globJSON={globJSON}
            txtInitials={userName.userInitialsName}
            txtPrimary={userName.userName}
            withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
            avatarColor={colorToUse(getColorIndex(index))}
            withCollapse
            withCircle={withCircle}
          />
          <MyContactLine
            simPlatform={simPlatform}
            globJSON={globJSON}
            txtInitials={userName.userInitialsName}
            txtPrimary={Bank_name_str}
            txtSecondary={phone_number_one}
            withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
            avatarColor={colorToUse(getColorIndex(index))}
            emptyBackground
            withCircle={withCircle}
          />
          <MyContactLine
            simPlatform={simPlatform}
            globJSON={globJSON}
            txtInitials={userName.userInitialsName}
            txtPrimary={Phone_str}
            txtSecondary={phone_number_zero}
            withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
            avatarColor={colorToUse(getColorIndex(index))}
            emptyBackground
            selectedContact={withSelected}
            withCircle={withCircle}
          />
        </View>
      ))))}
    </ScrollView>
  );
};
export default ContactListScroll;
